export * from './tabs.module'